import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, Users } from 'lucide-react';
import { Link as ScrollLink } from 'react-scroll';

const C2CFinalCTA = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-green-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-4xl mx-auto"
          >
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
              Limited Slots Available
            </h2>
            
            <p className="text-xl md:text-2xl text-blue-100 mb-8">
              Join the next generation of Nigerian exporters
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
              <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 text-white">
                <Clock className="h-5 w-5 mr-2" />
                <span>Registration closes soon</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 text-white">
                <Users className="h-5 w-5 mr-2" />
                <span>Only 50 spots per cohort</span>
              </div>
            </div>

            <ScrollLink
              to="how-to-join"
              smooth={true}
              duration={800}
              className="group inline-flex items-center px-12 py-6 bg-white text-blue-600 rounded-full font-bold text-xl hover:bg-blue-50 transition-all duration-300 transform hover:scale-105 cursor-pointer shadow-2xl"
            >
              Register Now – It's Free
              <ArrowRight className="ml-3 h-6 w-6 group-hover:translate-x-1 transition-transform" />
            </ScrollLink>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 }}
              className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <div className="text-3xl font-bold text-white mb-2">6</div>
                <div className="text-blue-100">Weeks Training</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <div className="text-3xl font-bold text-white mb-2">100%</div>
                <div className="text-blue-100">Free Program</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6">
                <div className="text-3xl font-bold text-white mb-2">₹0</div>
                <div className="text-blue-100">Your Investment</div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default C2CFinalCTA;